import React, { useEffect, useState } from "react";
import $ from "jquery";
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";
import '../../assets/css/custom.css';
const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [allImagesLoaded, setAllImagesLoaded] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:74/api/v1";

  useEffect(() => {
    fetch(`${API_URL}/gallery`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch gallery data");
        return res.json();
      })
      .then((data) => {
        setImages(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [API_URL]);

  const handleImageLoad = () => {
    setImagesLoaded(prev => {
      const newCount = prev + 1;
      if (newCount === images.length) {
        setAllImagesLoaded(true);
      }
      return newCount;
    });
  };
  useEffect(() => {
    if (!allImagesLoaded) return;

    const $gallery = $(".gallery");
    if ($gallery.length === 0) return;

    $gallery.magnificPopup({
      delegate: "a",
      type: "image",
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: "mfp-with-zoom mfp-img-mobile",
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: true,
        duration: 300,
        opener: function (element) {
          return element.find("img");
        },
      },
    });

    return () => {
      $gallery.magnificPopup("destroy");
    };
  }, [allImagesLoaded]); // Run only after all images are loaded
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  return (
    <section className="gallery" id="gallery">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title">
              <h2>Discover Your Next Workspace</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="container">
            <div className="masonry">
              {images.length > 0 ? (
                images.map((img, index) => (
                  <div className="brick gallery-item" key={img.galleryID || index}>
                    <a href={img.galleryPhoto} data-source={img.galleryPhoto}>
                      <img src={img.galleryPhoto} alt={img.galleryName || "Gallery Image"}
                      onLoad={handleImageLoad}/>
                    </a>
                  </div>
                ))
              ) : (
                <p>No images available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
